module.exports = __webpack_public_path__ + "img/knet.90b40c91.png";